import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '@app/store/reducer'

const bookingStateSelector = (state: AppState) => state.booking

export const flowDataSelector = createSelector(bookingStateSelector, ({ flowData }) => flowData)

export const inputDataSelector = createSelector(bookingStateSelector, ({ inputData }) => inputData)

export const stepSelector = createSelector(bookingStateSelector, ({ flowData: { currentStep } }) => currentStep)

export const testVariantIdLocationFilterSelector = createSelector(
  bookingStateSelector,
  ({ abTestsData: { testVariantIdLocationFilter } }) => testVariantIdLocationFilter
)

export const createLeadStatusSelector = createSelector(bookingStateSelector, ({ createLeadStatus }) => createLeadStatus)
export const bookingStatusSelector = createSelector(bookingStateSelector, ({ status }) => status)
